import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Box,
} from '@chakra-ui/react';
import { useFeatureFlag } from 'hooks/useFeatureFlag';

const BaraFeatureGuard = ({
  children,
  silent = false,
}: {
  children: React.ReactNode;
  silent?: boolean;
}) => {
  const isBaraEnabled = useFeatureFlag('enable-bara');

  if (!isBaraEnabled) {
    if (silent) return null;
    return (
      <Box pt={{ base: '130px', md: '80px' }} px={{ base: 4, md: 6 }}>
        <Alert status="info" borderRadius="md">
          <AlertIcon />
          <AlertTitle>Feature not activated.</AlertTitle>
          <AlertDescription>
            The Broker after-hours referral feature is not enabled for your
            organisation.
          </AlertDescription>
        </Alert>
      </Box>
    );
  }

  return <>{children}</>;
};

export default BaraFeatureGuard;
